// extracted by mini-css-extract-plugin
export default {"melodyVideo":"nL-z","isFullWidth":"oL-z","landingPageVideo":"pL-z","play":"qL-z","iframeVideo":"rL-z","playHidden":"sL-z","fullwidth":"tL-z"};